import { resolveCanonicalEnv, CANONICAL_HOSTS } from "./environment";

// 요청이 어느 호스트로 들어왔는지. CloudFront → ALB 를 거치면 원래 호스트가
// x-forwarded-host 에 담긴다(notification.js 와 동일한 규칙).
const resolveRequestHost = (req) => {
  const forwarded = req?.headers?.["x-forwarded-host"];
  const host = Array.isArray(forwarded)
    ? forwarded[0]
    : forwarded || req?.headers?.host || req?.hostname || "";
  return String(host).split(":")[0].toLowerCase();
};

export default {
  apiKey: "5@Q4&g28{s[CaddM(7:7#RV[",
  session: {
    minute: 30,
    secret: "WEBINARS-20200810",
  },
  cookie: {
    secret: "WEBINARS-20200810",
  },
  slack: {
    errorHook:
      "https://hooks.slack.com/services/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",
  },
  thumbnail: {
    size: 600,
    videoSize: "600x338",
    pointSize: { width: 300, height: 300 },
    pdf: {
      "-resize": "1000x1000",
      "-quality": "100",
    },
  },
  mediaConvert: {
    endpoint: "https://bnklbqvoa.mediaconvert.ap-northeast-2.amazonaws.com",
    role: "arn:aws:iam::460799851857:role/webinarsMediaConvert",
  },
  separator: "/",
  tmpDir: "tmp",
  logDir: "logs",
};


export const S3UploadPrepare = () => {
  if (process.env.STAGE === "prod") {
    return {
      region: "ap-northeast-2",
      public: {
        bucket: "medinar-files-public-prod",
        url: "https://cdn.livee.kr",
      },
      private: {
        bucket: "medinar-files-private-prod",
        url: "https://ccdn.livee.kr",
      },
    };
  } else if(process.env.STAGE === "stage") {
    // stage 를 검증 환경으로 분리하면서 stage 전용 버킷·CDN 으로 교정(2026-07-29).
    // 이전에는 dev 와 문자 그대로 같은 값이라, stage 업로드가 dev 버킷에 섞이고
    // 파일 URL 도 dev CDN 을 가리켰다.
    // stage 버킷과 CDN 배포는 이미 존재했고 오리진도 stage 버킷을 보고 있었다.
    return {
      region: "ap-northeast-2",
      public: {
        bucket: "medinar-files-public-stage",
        url: "https://cdn.sharewebinar.com",
      },
      private: {
        bucket: "medinar-files-private-stage",
        url: "https://ccdn.sharewebinar.com",
      },
    };
  }else  {
    return {
      region: "ap-northeast-2",
      public: {
        bucket: "medinar-files-public",
        url: "https://cdn.onoffevent.com",
      },
      private: {
        bucket: "medinar-files-private",
        url: "https://ccdn.onoffevent.com",
      },
    };
  }
};

export const CloudFront = {
  // stage 를 검증 환경으로 분리하면서 stage 전용 CDN 으로 교정(2026-07-29).
  // 이전에는 dev 사설 CDN(ccdn.onoffevent.com)을 가리켰다.
  url:
    process.env.STAGE === "prod" ? "https://ccdn.livee.kr/"
      : process.env.STAGE === "stage" ? "https://ccdn.sharewebinar.com/"
      : "https://ccdn.onoffevent.com/",
  options: {
    keypairId: process.env.CLOUDFRONT_KEYPAIR_ID || "APKAJU7SMLMY2XAYLU5A",
    privateKeyString: (process.env.CLOUDFRONT_PRIVATE_KEY || "").replace(/\\n/g, "\n"),
  },
};

export const CloudFrontFile = {
  // stage 를 검증 환경으로 분리하면서 stage 전용 CDN 으로 교정(2026-07-29).
  // 이전에는 dev CDN(cdn.onoffevent.com)을 가리켰다.
  url:
    process.env.STAGE === "prod" ? "https://ccdn.livee.kr/"
      : process.env.STAGE === "stage" ? "https://cdn.sharewebinar.com/"
      : "https://cdn.onoffevent.com/",
  options: {
    keypairId: process.env.CLOUDFRONT_FILE_KEYPAIR_ID || "K228UPN5JKBJ90",
    privateKeyString: (process.env.CLOUDFRONT_FILE_PRIVATE_KEY || "").replace(/\\n/g, "\n"),
  },
};

export const tasInfo = () => {
  return {
    apiHost: "https://api.tason.com/tas-api/send",
    apiKey: "TFJ1P5-NGPDAH-7LITVM-M8G4D1_425",
    apiAuthId: "solution@webinars.co.kr",
    senderEmail: "support@livee.kr",
    senderName: "심포지엄사무국",
  };
};

export const directSendInfo = () => {
  return {
    apiHost: "https://directsend.co.kr/index.php/api_v2/mail_change_word",
    apiKey: "AVYOTiWefGvOeiu",
    sender: "support@livee.kr",
    // sender: "support@webinars.co.kr",
    sender_name: "심포지엄사무국",
    username: "webinarswx",
  };
};

export const apiStoreInfo = () => {
  return {
    apiHost: "https://api.apistore.co.kr",
    apiKey:
      "MTM2NDktMTYwMDQxMTYzODM3NS0yODU2MjE5NS1kMTNhLTRiMTEtOTYyMS05NWQxM2EwYjExYjA=",
    apiSMSPath: "/ppurio/1/message/sms/webinars",
    apiSendNumberPath: "/ppurio/2/sendnumber/save/webinars",
    apiTalkPath: "/kko/1/msg/webinars",
    apiTalkCheckPath: "/kko/1/report/webinars",
    senderPhone: "0263426830",
    senderName: "(주)웨비나스",
  };
};

export const tossInfo = () => {
  return {
    // tossClientKey: "live_ck_ADpexMgkW36pv92DDY4rGbR5ozO0",
    // tossSecretKey: "live_sk_d26DlbXAaV0j6AYm7k08qY50Q9RB",
    tossClientKey: "test_ck_dP9BRQmyarYaxl2nE09rJ07KzLNk",
    tossSecretKey: "test_sk_Z0RnYX2w532bMEwwDgx3NeyqApQE",
  };
};

export const APIUrl = () => {
  switch (process.env.STAGE) {
    case "prod":
      return "https://api.livee.kr";
    case "dev":
      return "https://api.onoffevent.com";
    case "stage":
        return "https://api.sharewebinar.com";
    default:
      return `http://localhost:${process.env.API_HTTP_PORT || 3100}`;
  }
};

export const DSUrl = () => {
  switch (process.env.STAGE) {
    case "prod":
      return "https://api.livee.kr";
    case "stage":
      return "https://api.sharewebinar.com";      
    default: 
      return "https://api.onoffevent.com";
  }
};

export const NCloudConfig = () => {
  return {
    // CR-H4: NCP IAM 키는 env 주입만 허용한다(소스 하드코딩 금지 — 키 로테이션 시 env만 교체).
    // 미설정이면 NCloud API 호출이 인증 실패한다. 로컬은 root local.env, Lambda 는 serverless.yml,
    // ECS 는 ci-cd.yml taskdef env 로 주입한다.
    accessKey: process.env.NCLOUD_ACCESS_KEY || "",
    secretKey: process.env.NCLOUD_SECRET_KEY || "",
    region: "KR",
    liveStation: {
      baseUrl: "https://livestation.apigw.ntruss.com",
      apiVersion: "/api/v2",
      memberNo: "3131157",
      testVideoUrl: "https://cdn.onoffevent.com/transmission.mp4",
      globalEdgeProfileId: "4460",
    },
  };
};

const readJsonConfig = (value) => {
  if (!value) return {};

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
};

export const OpenAIConfig = (options = {}) => {
  const secretConfig = readJsonConfig(process.env.OPENAI_CONFIG_JSON);
  const apiKey = process.env.OPENAI_API_KEY || secretConfig.apiKey || null;
  const organizationId =
    process.env.OPENAI_ORG_ID || secretConfig.organizationId || null;
  const projectId = process.env.OPENAI_PROJECT_ID || secretConfig.projectId || null;
  const missingApiKey = !apiKey;

  if (options.requireApiKey === true && missingApiKey) {
    throw new Error("OPENAI_API_KEY is required for OpenAI STT.");
  }

  return {
    apiKey,
    organizationId,
    projectId,
    missingApiKey,
  };
};

// canonical 도메인 전환(2026-07-30): STAGE 만 보면 hc.stage.livee.kr 로 접속한
// 운영자에게도 hc.sharewebinar.com 링크가 발급됐다(가입요청 메일·초대 링크).
// 접속한 주소로 링크가 나가야 하므로 요청 호스트를 우선 반영한다.
//
// req 를 넘기지 않는 기존 호출부는 그대로 STAGE 기반으로 동작한다(무회귀).
export const HubUrl = (req = null) => {
  const canonicalEnv = req ? resolveCanonicalEnv(resolveRequestHost(req)) : null;
  if (canonicalEnv) {
    return CANONICAL_HOSTS[canonicalEnv].hub;
  }

  switch (process.env.STAGE) {
    case "prod":
      return "https://hc.livee.kr";
    case "dev":
      return "https://hub.onoffevent.com";
    case "stage":
      return "https://hc.sharewebinar.com";
    default:
      return `http://localhost:${process.env.HUB_PORT || 3000}`;
  }
};
